module.exports = __webpack_public_path__ + "static/img/top-logo.c18bb99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/top-logo.png
// module id = e4YE
// module chunks = 0